import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class PrestadorTipoAgendamentoService {

    async listPrestadoresTipoAgendamento(iss, dados) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('prestador-tipo-agendamento');
        const idEmpresa = RoleService.getEmpresa()
        const idPrestador = RoleService.getPrestador()
        const param = {}

        switch (accessLevel) {
            case 'GLOBAL':
                // return this.listAllPrestadorTipoAgendamento(iss);
                param.company_id = dados.company_id;
                param.all = true;
                return this.getByCompanyOrPrestador(iss, param);
            case 'COMPANY':
                param.company_id = idEmpresa;
                param.all = true;
                return this.getByCompanyOrPrestador(iss, param);
            case 'SELF':
                param.prestador_id = idPrestador
                return this.getByCompanyOrPrestador(iss, param);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllPrestadorTipoAgendamento(data) {
        return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${data}/get`)
    }

    getByCompanyOrPrestador(iss, dados) {
        return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${iss}/getByCompanyOrPrestador/`, {
            params: dados
        });
    }

    getPrestadorTipoAgendamento(data, id, companyId, prestadorId, tipoAgendamentoId) {
        if (tipoAgendamentoId && prestadorId)
            return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${data}/get?prestador=${prestadorId}&tipo=${tipoAgendamentoId}`)

        if (companyId)
            return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${data}/get?companies.id=${companyId}&join=true`)

        if (prestadorId)
            return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${data}/get?prestador.id=${prestadorId}&join=true`)

        return axiosInstance.get(`${config.api.version}/prestador/tipo/agendamento/${data}/get/${id}`)
    }

    postPrestadorTipoAgendamento(data, tipo) {
        return axiosInstance.post(`${config.api.version}/prestador/tipo/agendamento/${data}/`, tipo)
    }

    putPrestadorTipoAgendamento(data, tipo, id) {
        return axiosInstance.put(`${config.api.version}/prestador/tipo/agendamento/${data}/${id}`, tipo)
    }

    deletePrestadorTipoAgendamento(data, id) {
        return axiosInstance.delete(`${config.api.version}/prestador/tipo/agendamento/${data}/${id}`)
    }


}